/**
 * Created by Karan variya on 24/12/2018.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { FillingStationDeletedComponent } from './fillingstationdeleted.page';
export const routes: Routes = [
    { path: 'fillingstationdeleted', component: FillingStationDeletedComponent }
];
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        FillingStationDeletedComponent
    ]
})
export class FillingStationDeletedModule { }


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/fillingstationdeleted/fillingstationdeleted.module.ts